import type { AnswerValue, WizardAnswers } from "@/types";

export function asList(value: AnswerValue): string[] {
  if (Array.isArray(value)) return value;
  if (typeof value === "string" && value.length > 0) return [value];
  return [];
}

export function hasProduct(answers: WizardAnswers, productId: string): boolean {
  return asList(answers.products).includes(productId);
}

export function pruneAnswers(
  answers: WizardAnswers,
  visibleIds: string[],
): WizardAnswers {
  const next: WizardAnswers = {};
  for (const id of visibleIds) {
    if (answers[id] !== undefined) {
      next[id] = answers[id];
    }
  }
  return next;
}

export function isAnswered(value: AnswerValue): boolean {
  if (Array.isArray(value)) return value.length > 0;
  return Boolean(value);
}
